import * as React from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  Typography,
} from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import SchoolIcon from '@mui/icons-material/School';
import SpeedIcon from '@mui/icons-material/Speed';
import BuildIcon from '@mui/icons-material/Build';
import { Link } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

function Services({ t, i18n }) {
  const isFrench = i18n.language?.startsWith('fr');

  const services = [
    {
      to: '/services/conseil',
      icon: <SupportAgentIcon />,
      title: t('Services.conseil.titre'),
      description: t('Services.conseil.description'),
    },
    {
      to: '/services/academie',
      icon: <SchoolIcon />,
      title: t('Services.academie.titre'),
      description: t('Services.academie.description'),
    },
    {
      to: '/services/performance',
      icon: <SpeedIcon />,
      title: t('Services.performance.titre'),
      description: t('Services.performance.description'),
    },
    {
      to: '/services/technologie',
      icon: <BuildIcon />,
      title: t('Services.techno.titre'),
      description: t('Services.techno.description'),
    },
  ];

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        py: { xs: 4, md: 7 },

        '&::after': {
          content: '""',
          position: 'absolute',
          zIndex: 0,

          width: { xs: 320, md: 480 },
          height: { xs: 320, md: 480 },
          top: { xs: -160, md: -240 },
          right: { xs: -160, md: -240 },

          borderRadius: '50%',
          background: `
            radial-gradient(
              circle,
              rgba(159, 22, 34, 0.10) 0 34%,
              rgba(159, 22, 34, 0.045) 35% 65%,
              transparent 66%
            )
          `,
          pointerEvents: 'none',
        },
      }}
    >
      <Container
        maxWidth="lg"
        sx={{
          position: 'relative',
          zIndex: 1,
        }}
      >
        <Grid container spacing={3}>
          {services.map(
            ({ to, icon, title, description }) => (
              <Grid item xs={12} sm={6} key={to}>
                <Paper
                  component={Link}
                  to={to}
                  elevation={0}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    minHeight: 285,
                    p: { xs: 3, md: 4 },
                    color: 'text.primary !important',
                    border:
                      '1px solid rgba(31, 41, 55, 0.09)',
                    borderRadius: 5,
                    backgroundColor:
                      'rgba(255, 255, 255, 0.86)',
                    boxShadow:
                      '0 18px 50px rgba(31, 41, 55, 0.07)',

                    '&:hover': {
                      transform: 'translateY(-7px)',
                      boxShadow:
                        '0 24px 60px rgba(31, 41, 55, 0.13)',

                      '& .service-arrow': {
                        transform: 'translateX(5px)',
                      },
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: 'grid',
                      placeItems: 'center',
                      width: 58,
                      height: 58,
                      mb: 3,
                      borderRadius: 3,
                      color: 'primary.main',
                      backgroundColor:
                        'rgba(159, 22, 34, 0.09)',

                      '& svg': {
                        fontSize: 30,
                      },
                    }}
                  >
                    {icon}
                  </Box>

                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: {
                        xs: '1.45rem',
                        md: '1.7rem',
                      },
                      mb: 1.5,
                    }}
                  >
                    {title}
                  </Typography>

                  <Typography
                    sx={{
                      flexGrow: 1,
                      color: 'text.secondary',
                    }}
                  >
                    {description}
                  </Typography>

                  <Button
                    component="span"
                    endIcon={
                      <ArrowForwardRoundedIcon
                        className="service-arrow"
                        sx={{
                          transition: 'transform 0.2s ease',
                        }}
                      />
                    }
                    sx={{
                      alignSelf: 'flex-start',
                      mt: 2.5,
                      px: 0,
                    }}
                  >
                    {isFrench
                      ? 'En savoir plus'
                      : 'Learn more'}
                  </Button>
                </Paper>
              </Grid>
            ),
          )}
        </Grid>
      </Container>
    </Box>
  );
}

export default withTranslation()(Services);